module.exports = __webpack_public_path__ + "img/offeo.de3b8509.jpg";